/* eslint-disable no-unused-vars */
const toogleSubNavMobile = () => {
    const sectionSubNav = document.querySelector(".section-sub-nav");
    if (!sectionSubNav) return;

    let hoverTimeout = null;

    // helpers
    const openItem = li => {
        const sub = li.querySelector(".sub-nav-items");
        const btn = li.querySelector(".button-collapse");
        const itm = li.querySelector(".item-collapse");

        if (sub) sub.classList.add("active", "hoverActive");
        if (btn) btn.classList.add("button-collapse-active");
        if (itm) itm.classList.add("active-item");
    };

    const closeItem = li => {
        const sub = li.querySelector(".sub-nav-items");
        const btn = li.querySelector(".button-collapse");
        const itm = li.querySelector(".item-collapse");

        if (sub) sub.classList.remove("active", "hoverActive");
        if (btn) btn.classList.remove("button-collapse-active");
        if (itm) itm.classList.remove("active-item");
    };

    // Find all top-level nav sections (each sectionNav component renders a <li>)
    const navSections = Array.from(sectionSubNav.querySelectorAll(".navigation > li"));

    navSections.forEach(navLi => {
        const itemNav = navLi.querySelector(".title");
        const buttonSubNav = navLi.querySelector(".title .button-collapse");
        const dropdownList = navLi.querySelector(".dropdown-list-wrapper");
        const listItems = Array.from(navLi.querySelectorAll(".dropdown-list > li"));

        const closeAll = () => {
            listItems.forEach(li => closeItem(li));
            if (dropdownList) dropdownList.classList.remove("active");
            if (buttonSubNav) buttonSubNav.classList.remove("button-collapse-active");
        };

        const closeAllExcept = currentLi => {
            listItems.forEach(li => {
                if (li !== currentLi) closeItem(li);
            });
        };

        // --- Top-level main dropdown toggle ---
        if (itemNav && dropdownList && buttonSubNav) {
            itemNav.addEventListener("click", e => {
                if (e.target.closest(".button-collapse")) return;
                dropdownList.classList.toggle("active");
                buttonSubNav.classList.toggle("button-collapse-active");
            });
        }

        // --- Top-level arrow (button-collapse) toggle ---
        if (buttonSubNav && dropdownList) {
            buttonSubNav.addEventListener("click", e => {
                e.preventDefault();
                e.stopPropagation();

                const isOpen = dropdownList.classList.contains("active");

                if (isOpen) {
                    dropdownList.classList.remove("active");
                    buttonSubNav.classList.remove("button-collapse-active");
                } else {
                    dropdownList.classList.add("active");
                    buttonSubNav.classList.add("button-collapse-active");
                }
            });
        }

        // --- Per item handlers ---
        listItems.forEach(li => {
            const buttonItemCollapse = li.querySelector(".button-collapse");
            const subNavItem = li.querySelector(".sub-nav-items");

            if (!subNavItem || !buttonItemCollapse) return;

            // DESKTOP
            li.addEventListener("mouseenter", () => {
                if (window.innerWidth > 1024) {
                    clearTimeout(hoverTimeout);
                    closeAllExcept(li);
                    openItem(li);
                }
            });

            li.addEventListener("mouseleave", () => {
                if (window.innerWidth > 1024) {
                    hoverTimeout = setTimeout(() => {
                        closeItem(li);
                    }, 600);
                }
            });

            buttonItemCollapse.addEventListener("click", e => {
                e.preventDefault();
                e.stopPropagation();

                const isActive = subNavItem.classList.contains("active");

                if (isActive) {
                    closeItem(li);
                } else {
                    closeAllExcept(li);
                    openItem(li);
                }
            });

            buttonItemCollapse.addEventListener("keydown", e => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    buttonItemCollapse.click();
                }
            });
        });

        document.addEventListener("click", e => {
            if (!sectionSubNav.contains(e.target)) {
                closeAll();
            }
        });

        window.addEventListener("resize", () => {
            closeAll();
        });
    });
};

function init() {
    toogleSubNavMobile();
}

export default { init };
